
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/sponsorships/sponsors",
      function () {
        return require("private-next-pages/admin/sponsorships/sponsors.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/sponsorships/sponsors"])
      });
    }
  